<div class="exception-body">
    <div class="exception-bottom">
        <div class="exception-wrapper">
            <img src="../../../assets/layout/images/accountInprogress.png" alt="unconfirmed user" width="80%">
            <h3 class="subHeader">Your Account Configuration is in Progress !</h3>
            <button pButton pRipple type="button" label="Back to Login" class="cozmos-secondary-button"
                (click)="redirectToLogin()"></button>
        </div>
    </div>
</div>